<script setup>
import debounce from 'lodash/debounce'

const props = defineProps({
    min: {
        type: Number,
        default: 0
    },
    max: {
        type: Number,
        default: 10
    },
    step: {
        type: Number,
        default: 1
    },
    initialValue: {
        type: String,
        default: null
    },
    renderer: {
        type: Function,
        required: true
    },
    label: {
        type: Object,
        required: true
    }
})

const { $getI18n } = useNuxtApp()
const emits = defineEmits(['updateFilter'])

const modelValue = ref([props.min, props.max])
const updateFilter = (payload) => {
    modelValue.value = payload
    const payloadString = `${payload[0] ? payload[0] : ''}/${payload[1] ? payload[1] : ''}`
    debouncedEmitUpdate(payloadString)
}

const debouncedEmitUpdate = debounce((payloadString) => {
    emits('updateFilter', payloadString)
}, 500)

onMounted(() => {
    if (props.initialValue) {
        modelValue.value = props.initialValue.split('/')
    }
})
</script>
<template>
    <div class="single-filter-ui">
        <div class="filter-title d-flex justify-space-between">
            <span class="text-subtitle-2">{{ $getI18n(label) }}</span>
            <span class="text-subtitle-2">{{
                `${renderer(modelValue[0])} - ${renderer(modelValue[1])}`
            }}</span>
        </div>
        <v-range-slider
            :min="props.min"
            :max="props.max"
            :model-value="modelValue"
            :step="props.step"
            track-color="#d0d0d0"
            color="primary"
            thumb-color="#ffffff"
            track-size="6"
            hide-details
            class="mb-2"
            @update:modelValue="updateFilter([$event[0], $event[1]])"
        ></v-range-slider>
    </div>
</template>
